// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "de2bc4cb77835fd6","396": "a02a69587ce2a6cf","460": "effaf229ab128c3d","498": "db77a41a3dcdb883","917": "f0b4640219829465","985": "b37d9bb69db3f62c",}[chunkId] + ".chunk.js"
}